import React, { useState, Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Login } from './components/Login';
import { Dashboard } from './components/Dashboard';

const PodsView = lazy(() => import('./views/PodsView'));
const NodesView = lazy(() => import('./views/NodesView'));
const DeploymentsView = lazy(() => import('./views/DeploymentsView'));
const NamespacesView = lazy(() => import('./views/NamespacesView'));
const EventsView = lazy(() => import('./views/EventsView'));
const MetricsView = lazy(() => import('./views/MetricsView'));
const ChartsView = lazy(() => import('./views/ChartsView'));
const AlertsView = lazy(() => import('./views/AlertsView'));
const RulesView = lazy(() => import('./views/RulesView'));
const SettingsView = lazy(() => import('./views/SettingsView'));

export default function App() {
  const [token, setToken] = useState(localStorage.getItem('k3s_token'));
  function logout() { localStorage.removeItem('k3s_token'); setToken(null); }
  
  if (!token) return <Login onLogin={t => setToken(t)}/>;
  
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Dashboard onLogout={logout}/>}>
          <Route index element={<Navigate to="pods" replace />} />
          <Route path="pods" element={<Suspense fallback={<div style={{padding: 20}}>Loading...</div>}><PodsView /></Suspense>} />
          <Route path="nodes" element={<Suspense fallback={<div style={{padding: 20}}>Loading...</div>}><NodesView /></Suspense>} />
          <Route path="deployments" element={<Suspense fallback={<div style={{padding: 20}}>Loading...</div>}><DeploymentsView /></Suspense>} />
          <Route path="namespaces" element={<Suspense fallback={<div style={{padding: 20}}>Loading...</div>}><NamespacesView /></Suspense>} />
          <Route path="events" element={<Suspense fallback={<div style={{padding: 20}}>Loading...</div>}><EventsView /></Suspense>} />
          <Route path="metrics" element={<Suspense fallback={<div style={{padding: 20}}>Loading...</div>}><MetricsView /></Suspense>} />
          <Route path="history" element={<Suspense fallback={<div style={{padding: 20}}>Loading...</div>}><ChartsView /></Suspense>} />
          <Route path="alerts" element={<Suspense fallback={<div style={{padding: 20}}>Loading...</div>}><AlertsView /></Suspense>} />
          <Route path="rules" element={<Suspense fallback={<div style={{padding: 20}}>Loading...</div>}><RulesView /></Suspense>} />
          <Route path="settings" element={<Suspense fallback={<div style={{padding: 20}}>Loading...</div>}><SettingsView /></Suspense>} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
